/**
 * Attach a granted MediaStream only after the preview element is in the DOM.
 * Assigning srcObject before that mount, then skipping the follow-up effect,
 * leaves a blank pane even though Join is already enabled.
 */
export function attachPreviewStream(
  video: HTMLVideoElement | null,
  stream: MediaStream | null,
): void {
  if (!video || !stream) return;
  const previewVideo = video;
  // eslint-disable-next-line no-param-reassign -- bind stream on the caller's preview element
  previewVideo.srcObject = stream;
  previewVideo.play().catch(() => undefined);
}
